(function () {
document.querySelectorAll('.pkb').forEach(function (root) {
  if (root.dataset.ready) return; root.dataset.ready = 1;
  function J(sel) { try { return JSON.parse(root.querySelector(sel).textContent); } catch (e) { return null; } }
  var cfg = J('[data-cfg]') || {}, variants = J('[data-variants]') || [], meta = J('[data-meta]') || {};
  var LANG = String(meta.lang || 'en'), LB = LANG.toLowerCase().split('-')[0], PT = LB === 'pt', SEP = ' · ';
  var I18N = J('[data-i18n]') || {};
  function D(s) { var x = document.createElement('textarea'); x.innerHTML = s == null ? '' : String(s); return x.value; }
  function L(k, fb) { return I18N[k] != null && I18N[k] !== '' ? D(I18N[k]) : fb; }
  var LBL = cfg.labels_pt || {};
  /* es/de/fr/it: dicionário EN -> idioma (snippets/exh-pack-dict.liquid). pt-PT usa .pt/labels_pt; en usa .en. */
  var DICT = (PT || LB === 'en') ? null : J('[data-dict]');
  function rx(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  var PATS = [];
  if (DICT && DICT.patterns) DICT.patterns.forEach(function (p) {
    if (!p || !p.en || !p[LB] || p.en.indexOf('{model}') < 0) return;
    PATS.push({ re: new RegExp('^' + p.en.split('{model}').map(rx).join('([\\s\\S]+?)') + '$'), to: p[LB] });
  });
  function loc(en) {
    if (!DICT || !en) return en;
    var ex = DICT.exact && Object.prototype.hasOwnProperty.call(DICT.exact, en) ? DICT.exact[en] : null;
    if (ex && ex[LB]) return ex[LB];
    for (var i = 0; i < PATS.length; i++) { var m = en.match(PATS[i].re); if (m) return PATS[i].to.split('{model}').join(m[1] === en ? m[1] : loc(m[1])); }
    return en;
  }
  function tr(s) { return PT ? (LBL[s] || s) : loc(s); }
  function T(o) { return o ? (PT ? (o.pt || o.en) : loc(o.en || o.pt)) : ''; }
  function money(c) {
    var o = { style: 'currency', currency: 'EUR' };
    try { return (c / 100).toLocaleString(LANG, o); } catch (e) { return (c / 100).toLocaleString('en-GB', o); }
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function lvlName(part, stepCfg, depth) {
    if (/^\d+\s?mm$/i.test(part)) return L('size', 'Size');
    var names = stepCfg.levels || [];
    return T(names[depth]) || '';
  }
  var opts = meta.options || [];
  var chosen = {};
  var first = variants.find(function (v) { return v.available; }) || variants[0];
  opts.forEach(function (o, i) { chosen[o] = (first.options[i] || '').split(SEP); });
  function valuesFor(optIdx) {
    var seen = {}, out = [];
    variants.forEach(function (v) { var x = v.options[optIdx]; if (!seen[x]) { seen[x] = 1; out.push(x.split(SEP)); } });
    return out;
  }
  function currentVariant() {
    return variants.find(function (v) { return opts.every(function (o, i) { return v.options[i] === chosen[o].join(SEP); }); });
  }
  function imgFor(stepCfg, parts, depth) {
    var map = (stepCfg && stepCfg.images) || {};
    for (var d = depth; d >= 0; d--) { var k = parts.slice(0, d + 1).join(SEP); if (map[k]) return map[k]; }
    return null;
  }
  var hero = root.querySelector('[data-hero]'), cap = root.querySelector('[data-cap]');
  function showHero(src, caption) {
    if (!src) return;
    hero.style.opacity = .2;
    var im = new Image(); im.onload = function () { hero.src = src; hero.style.opacity = 1; }; im.src = src;
    cap.hidden = !caption; cap.textContent = caption || '';
  }
  function renderSteps() {
    var box = root.querySelector('[data-steps]'); var html = ''; var n = 0;
    opts.forEach(function (o, oi) {
      var sc = (cfg.steps || {})[o] || {};
      var all = valuesFor(oi); var cur = chosen[o];
      var maxDepth = Math.max.apply(null, all.map(function (p) { return p.length; }));
      if (all.length < 2) return;
      n++;
      html += '<div class="step" data-opt="' + esc(o) + '"><h3><span class="n">' + n + '</span>' + esc(T(sc.label) || o) + '<span class="sel">' + esc(cur.map(tr).join(' · ')) + '</span></h3>';
      var ci = imgFor(sc, cur, cur.length - 1);
      if (ci) html += '<div class="cur"><img src="' + esc(ci) + '" alt=""></div>';
      for (var d = 0; d < maxDepth; d++) {
        var prefix = cur.slice(0, d).join(SEP);
        var cands = {}; var order = [];
        all.forEach(function (p) { if (p.length > d && p.slice(0, d).join(SEP) === prefix && !cands[p[d]]) { cands[p[d]] = p; order.push(p[d]); } });
        if (!order.length) continue;
        if (order.length === 1 && d > 0) continue;
        var withImg = order.some(function (val) { return imgFor(sc, cands[val].slice(0, d + 1), d); });
        html += '<div class="lvl"><p>' + esc(lvlName(order[0], sc, d)) + '</p><div class="' + (withImg && !/^\d+\s?mm$/i.test(order[0]) ? 'tiles' : 'pills') + '">';
        order.forEach(function (val) {
          var parts = cands[val].slice(0, d + 1); var on = cur[d] === val;
          var im = imgFor(sc, parts, d);
          if (withImg && !/^\d+\s?mm$/i.test(val)) html += '<button type="button" class="tile" aria-pressed="' + on + '" data-o="' + esc(o) + '" data-d="' + d + '" data-v="' + esc(val) + '">' + (im ? '<img src="' + esc(im) + '" alt="" loading="lazy">' : '') + '<span>' + esc(d === 0 && sc.keepFirst ? val : tr(val)) + '</span></button>';
          else html += '<button type="button" class="pill" aria-pressed="' + on + '" data-o="' + esc(o) + '" data-d="' + d + '" data-v="' + esc(val) + '">' + esc(tr(val)) + '</button>';
        });
        html += '</div></div>';
      }
      html += '</div>';
    });
    var bikeOpt = opts.find(function (o) { return (cfg.steps || {})[o] && cfg.steps[o].isBike; });
    var bikeVal = bikeOpt ? chosen[bikeOpt].join(SEP) : '*';
    var fixed = ((cfg.fixed || {})[bikeVal] || (cfg.fixed || {})['*'] || []);
    n++;
    html += '<div class="step"><h3><span class="n">' + n + '</span>' + esc(L('included', 'Included in the pack')) + '</h3><div class="incls">';
    fixed.forEach(function (it) { html += '<div class="incl" data-img="' + esc(it.img) + '" data-cap="' + esc(T(it.title)) + '"><img src="' + esc(it.img) + '" alt="" loading="lazy"><span>' + esc(T(it.title)) + '<small>' + esc(T(it.note)) + '</small></span></div>'; });
    html += '</div></div>';
    box.innerHTML = html;
    renderStrip(fixed);
  }
  function selectionImages() {
    var list = [];
    if (meta.feat) list.push({ img: meta.feat, cap: '' });
    if (cfg.base) list.push({ img: cfg.base.img, cap: T(cfg.base.title) });
    opts.forEach(function (o) { var sc = (cfg.steps || {})[o]; if (!sc || !sc.images) return; var p = chosen[o]; var im = imgFor(sc, p, p.length - 1); if (im && !sc.isBike) list.push({ img: im, cap: T(sc.label) + ': ' + p.map(tr).join(' · ') }); });
    return list;
  }
  function renderStrip(fixed) {
    var items = selectionImages().concat(fixed.map(function (f) { return { img: f.img, cap: T(f.title) }; }));
    var s = root.querySelector('[data-strip]');
    s.innerHTML = items.map(function (it, i) { return '<button type="button" aria-current="' + (i === 0) + '" data-img="' + esc(it.img) + '" data-cap="' + esc(it.cap) + '"><img src="' + esc(it.img) + '" alt="" loading="lazy"></button>'; }).join('');
  }
  function renderPrice() {
    var v = currentVariant();
    var btn = root.querySelector('[data-atc]');
    if (!v) { btn.disabled = true; return; }
    btn.disabled = !v.available;
    var save = v.compare - v.price;
    root.querySelector('[data-price]').textContent = money(v.price);
    root.querySelector('[data-compare]').textContent = save > 0 ? money(v.compare) : '';
    root.querySelector('[data-save]').textContent = save > 0 ? L('you_save', 'You save') + ' ' + money(save) : '';
    root.querySelector('[data-sum-compare]').textContent = money(v.compare);
    root.querySelector('[data-sum-save]').textContent = '− ' + money(save);
    root.querySelector('[data-sum-price]').textContent = money(v.price);
    var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
  }
  function pick(o, d, val) {
    var oi = opts.indexOf(o); var all = valuesFor(oi);
    var prefix = chosen[o].slice(0, d).concat([val]);
    var keep = chosen[o].slice(d + 1);
    var exact = all.find(function (p) { return p.slice(0, d + 1).join(SEP) === prefix.join(SEP) && p.slice(d + 1).join(SEP) === keep.join(SEP); });
    var any = all.find(function (p) { return p.slice(0, d + 1).join(SEP) === prefix.join(SEP); });
    chosen[o] = (exact || any).slice();
    renderSteps(); renderPrice();
    var sc = (cfg.steps || {})[o] || {};
    var im = imgFor(sc, chosen[o], chosen[o].length - 1);
    if (im) showHero(im, T(sc.label) + ': ' + chosen[o].map(tr).join(' · '));
    else if (meta.feat) showHero(meta.feat, '');
    else if (cfg.base) showHero(cfg.base.img, T(cfg.base.title));
  }
  root.addEventListener('click', function (e) {
    var b = e.target.closest('[data-o]');
    if (b) { pick(b.getAttribute('data-o'), +b.getAttribute('data-d'), b.getAttribute('data-v')); return; }
    var s = e.target.closest('[data-strip] button, .incl');
    if (s) {
      showHero(s.getAttribute('data-img'), s.getAttribute('data-cap'));
      root.querySelectorAll('[data-strip] button').forEach(function (x) { x.setAttribute('aria-current', x === s); });
      return;
    }
    if (e.target.closest('[data-atc]')) addToCart();
  });
  function addToCart() {
    var v = currentVariant(); if (!v) return;
    var btn = root.querySelector('[data-atc]'), msg = root.querySelector('[data-msg]');
    btn.disabled = true; msg.textContent = L('adding', 'Adding…');
    fetch(meta.add || '/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function () {
        msg.textContent = L('added', 'Pack added to cart.');
        var d = document.querySelector('m-cart-drawer');
        try {
          if (d && d.onCartDrawerUpdate) { d.onCartDrawerUpdate(); setTimeout(function () { d.open && d.open(); }, 300); return; }
        } catch (e) {}
        location.href = meta.cart || '/cart';
      })
      .catch(function () { msg.textContent = L('add_error', 'Could not add. Please try again.'); })
      .finally(function () { btn.disabled = false; });
  }
  renderSteps(); renderPrice();
  if (!meta.feat && cfg.base) showHero(cfg.base.img, T(cfg.base.title));
});
})();